<div class="page-title">
  {{ fileUpload.mainHeader }}
  <app-more-info-link [anchor]="contentfulAnchor" class="col"></app-more-info-link>
</div>
<div class="title-underline"></div>
<div class="page-container" [ngClass]="{ 'upload-file-container': uploadFile }">
  @if (!uploadFile) {
    <div>
      <div class="multiple-emp">
        <div class="heading-title">{{ fileUpload.multiple.headingTitle }}</div>
        <p class="heading-desc heading-desc-color" [appAddHtml]="fileUpload.multiple.headingDesc"></p>
        <button id="multipleEmpStartBtn" mat-flat-button class="mat-secondary tasc-btn float-left start-btn" (click)="uploadMultipleEmp()">Start</button>
      </div>
      <div class="col-2 divider-container">
        <div class="divider"></div>
      </div>
      <div class="single-emp">
        <div class="heading-title">{{ fileUpload.single.headingTitle }}</div>
        <p class="heading-desc heading-desc-color" [appAddHtml]="fileUpload.single.headingDesc"></p>
        <button data-cy="add-single-employee-button" id="singleEmpStartBtn" mat-flat-button class="mat-primary mat-flat-button start-btn" (click)="addSingleEmployee()">Start</button>
      </div>
    </div>
  }
  @if (uploadFile) {
    <app-upload-file [fileBrowse]="fileUpload.fileBrowse" (oncancel)="onCancelFileUpload()" (fileUploadSuccess)="onFileUploadSuccess($event)"></app-upload-file>
  }
</div>
